(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.switch = {
    attach: function (context, drupalSettings) {
      const switchElement = $('input.input-switch');
      if (switchElement.length) {
        const labelOn = $('.labelOn');
        const labelOff = $('.labelOff');
        const checkedSwitch = switchElement.get(0).checked;
        switchElement.on('change', function () {
          const that = $(this);
          switchActionHandler(that.attr("data-event-type"), that);
        })
        labelOn.on('click touch', function () {
          switchElement.prop('checked', true).change().blur()
        })
        labelOff.on('click touch', function () {
          switchElement.prop('checked', false).change().blur()
        })
        if (checkedSwitch) {
          $('.switch-wrapper').addClass('is_checked')
        }
      }
    }
  };

})(jQuery, Drupal);
